module.exports = __webpack_public_path__ + "public/img/img_01.98b2f7f4.png";